import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaddleBoard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 640 480",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "rotate(8.1253 325.1 239.95)",
		fillRule: "evenodd",
		stroke: "#000",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				transform: "rotate(29.228 455.93 84.938)",
				d: "m447 136.25l-4 2.75-1.5-0.25-1.5-0.25-1.5-0.25-1.5-0.25-1.75-6.5q-1.75-6.5-2.75-16.5t1.5-29.5 7.5-33.5 7.75-17.25l2.75-3.25 1-0.5q1-0.5 8.5 1t11.25 5.25 5.75 9.25 0.5 17-7.75 30.75-9.5 24.5-7 10-7.75 7.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				transform: "rotate(25.106 318 240)",
				d: "m354.5 89h0.5l1.5 0.25 1.5 0.25 1.5 0.25 1.5 0.25-1.25 11-1.25 11-2 2q-2 2-24.5 86t-29 108-10.5 43-3.75 20.5l0.25 1.5-1.75 0.5q-1.75 0.5-4 9l-2.25 8.5-1-0.25-1-0.25-2-0.25q-2-0.25-2-1.25v-1l1.25-5.5q1.25-5.5 1.25-10v-4.5l4.5-12q4.5-12 11-36t30.5-114 23.25-94.5l-0.75-4.5h2q2 0 4-9t2.5-9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				transform: "rotate(20.66 184.31 398.45)",
				d: "m197.75 348.5l1.25-1.5v1q0 1 2 1.25l2 0.25 1 0.25 1 0.25 0.75 2q0.75 2 2.25 17t1 18-5 21-7 24-7.25 10.75-13.75 6.25-11 0.5l-2-1-1.75-2.25q-1.75-2.25-1.75-12.25t3-22 9.5-26 15.5-25 10.25-12.5z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "rotate(260.3 325.23 233.95)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						transform: "rotate(29.228 460.93 78.938)",
						d: "m452 130.25l-4 2.75-1.5-0.25-1.5-0.25-1.5-0.25-1.5-0.25-1.75-6.5q-1.75-6.5-2.75-16.5t1.5-29.5 7.5-33.5 7.75-17.25l2.75-3.25 1-0.5q1-0.5 8.5 1t11.25 5.25 5.75 9.25 0.5 17-7.75 30.75-9.5 24.5-7 10-7.75 7.5z"
					}),
					/* @__PURE__ */ _jsx("path", {
						transform: "rotate(25.106 323 234)",
						d: "m359.5 83h0.5l1.5 0.25 1.5 0.25 1.5 0.25 1.5 0.25-1.25 11-1.25 11-2 2q-2 2-24.5 86t-29 108-10.5 43-3.75 20.5l0.25 1.5-1.75 0.5q-1.75 0.5-4 9l-2.25 8.5-1-0.25-1-0.25-2-0.25q-2-0.25-2-1.25v-1l1.25-5.5q1.25-5.5 1.25-10v-4.5l4.5-12q4.5-12 11-36t30.5-114 23.25-94.5l-0.75-4.5h2q2 0 4-9t2.5-9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						transform: "rotate(20.66 189.31 392.45)",
						d: "m202.75 342.5l1.25-1.5v1q0 1 2 1.25l2 0.25 1 0.25 1 0.25 0.75 2q0.75 2 2.25 17t1 18-5 21-7 24-7.25 10.75-13.75 6.25-11 0.5l-2-1-1.75-2.25q-1.75-2.25-1.75-12.25t3-22 9.5-26 15.5-25 10.25-12.5z"
					})
				]
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgPaddleBoard);
export { ForwardRef as ReactComponent };
